import {AfterViewInit, Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';

@Component({
  selector: 'pla-tab-stepper',
  templateUrl: './tab-stepper.component.html',
  styleUrls: ['./tab-stepper.component.scss']
})
export class TabStepperComponent implements OnInit, AfterViewInit {

  @ViewChild('stepperContainer') stepperContainer: ElementRef;
  @ViewChildren('stepContent') stepContents: QueryList<ElementRef>;

  @Input() tabs: { label: string, template: any }[] = [];
  @Input() activeColor: string = '#2563eb'; // blue-600
  @Input() inactiveColor: string = '#94a3b8'; // slate-400
  activeIndex = 0;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    // Wait for content to render
    setTimeout(() => this.adjustHeight(), 0);
  }

  adjustHeight(): void {
    const contentEl = this.stepContents?.get(this.activeIndex)?.nativeElement;
    const containerEl = this.stepperContainer?.nativeElement;

    if (contentEl && containerEl) {
      containerEl.style.height = contentEl.offsetHeight + 'px';
    }
  }
}
